/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReleaseRestrictionRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/release_restriction.pb'
import {ReleaseRestrictionResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/release_restriction.pb'


export const releaseRestriction = (request: ReleaseRestrictionRequest, options?: CashRequestOptions) => post<ReleaseRestrictionRequest, ReleaseRestrictionResponse>("/2.0/cash/release-restriction", request, {...options, rejectOnError: true })